import { EventEmitter, Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';
import { Events } from '@tencent/docs-titlebar-service';

@Feature()
export class RevisionRecordFeature extends BaseTitleBarFeature {
    constructor(private eventEmitter: EventEmitter) {
        super();
    }

    public showRevisionRecord() {
        if (this.getMenuManager()) {
            this.getMenuManager()?._actionRevisionRecord();
            this.eventEmitter.emit(Events.HIDE_COOPERATION);
        }
    }
}
